import {
  Component,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { AppSettings } from 'src/app/app.config';
import { CoreService } from 'src/app/services/core.service';
import { BrandingComponent } from '../../vertical/sidebar/branding.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';

@Component({
  selector: 'app-customizer',
  standalone: true,
  imports: [BrandingComponent, TablerIconsModule, MaterialModule, FormsModule, NgScrollbarModule, NgIf],
  templateUrl: './customizer.component.html',
  styleUrls: ['./customizer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomizerComponent {
   
  @Output() optionsChange = new EventEmitter<AppSettings>();
  constructor(private settings: CoreService) {}
  options = this.settings.getOptions();
  autoThemeEnabled = !localStorage.getItem('themePreference'); // Si no hay preferencia, el modo automático está activo

  setDark() {
    // Guardar la preferencia del usuario en localStorage
    localStorage.setItem('themePreference', this.options.theme);
    this.autoThemeEnabled = false;
    this.optionsChange.emit(this.options);
  }

  toggleAutoTheme() {
    if (this.autoThemeEnabled) {
      // Activar modo automático: eliminar preferencia guardada
      localStorage.removeItem('themePreference');
      // Aplicar tema automático inmediatamente
      const currentHour = new Date().getHours();
      const isNight = currentHour >= 20 || currentHour < 6;
      this.options.theme = isNight ? 'dark' : 'light';
      this.settings.setOptions(this.options);
      this.optionsChange.emit(this.options);
    } else {
      // Desactivar modo automático: guardar tema actual como preferencia
      localStorage.setItem('themePreference', this.options.theme);
    }
  }

  setColor() {
    this.optionsChange.emit(this.options);
  }

  setDir() {
    this.optionsChange.emit(this.options);
  }

  setSidebar() {
    this.optionsChange.emit(this.options);
  }

  setHorizontal() {
    // Persistir la orientación elegida (localStorage vía CoreService) y notificar
    this.settings.setOptions(this.options);
    this.optionsChange.emit(this.options);
  }
}
